module.exports = __webpack_public_path__ + "static/hero3-mobile-7dc275efd0c81cbbc79d11c4b35d4110.png";